import { setupBugsink, SetupBugsinkI } from '@common/utils/bugsink';
import { version } from '@root/package.json';
import { config } from './config';

setupBugsink({
  dsns: config.bugsinkDsns,
  version,
} as SetupBugsinkI);

import './components/TefComs4cs4p'; // eslint-disable-line -- import only after bugsink init
